import {Component, EventEmitter, Input, Output, TemplateRef} from '@angular/core';

@Component({
    selector: 'app-details-table-header',
    templateUrl: './details-table-header.component.html',
    styleUrls: ['./details-table-header.component.scss'],
    standalone: false
})
export class DetailsTableHeaderComponent {

  @Input() additionalRightContent: TemplateRef<any>;
  @Input() disableClearFilter = true;
  @Output() doSearch:EventEmitter<string> = new EventEmitter<string>();
  @Output() doResetFilter: EventEmitter<void> = new EventEmitter<void>();
  @Input() searchTerm: any;
  @Input() tableTitle: string;

  reset() {
      this.doResetFilter.emit();
  }

  onSearch(st: string) {
      this.searchTerm = st;
      this.doSearch.emit(st);
  }

}
